export class HxMetadata {
    public id: string = "";
    public developerName: string = "";
    public businessUnit: string = "";
    public businessUnitNumber: string = "";
    public deployWorkflow: boolean = false;
    public deployDispatch: boolean = false;
    public deployPortal: boolean = false;
    public partnerPortal: boolean = false;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/hx-metadata.ts